import React from 'react'
import PropTypes from 'prop-types'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import SmartRateWrapper from './SmartRateWrapper'
import { httpLink, authLink } from '../shared/ApolloClient'

const SmartRateDisplayContainer = (() => {

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
      dataIdFromObject: obj => {
        const { __typename } = obj
        if (__typename === 'PredictionModel') {
          return `${__typename}${obj.version}${obj.type}${obj.dataPermutation}`
        } else if (__typename === 'Product') {
          return `${__typename}${obj.lenderKey}${obj.name}`
        } else {
          return `${obj.__typename}${obj.rid ? obj.rid : obj.id}`
        }
      }
    })
  })

  return props => {
    return (
      <ApolloProvider client={client}>
        <SmartRateWrapper {...props} />
      </ApolloProvider>
    )
  }
})()

SmartRateDisplayContainer.propTypes = {
  defaultProbability: PropTypes.number,
  loanId: PropTypes.number.isRequired
}

export default SmartRateDisplayContainer
